export const CardTitle = ({ title, csx }) => {
  return <p className={`text-lg font-bold text-[#6C727F] ${csx}`}>{title}</p>
}

export const CardDataLabel = ({ title, csx }) => {
  return <span className={`text-sm font-medium text-[#6C727F] ${csx}`}>{title}</span>
}

export const CardDataValue = ({ title, csx }) => {
  return <span className={`text-md font-medium ${csx}`}>{title}</span>
}
